import React, { useCallback } from 'react'
import { SyncOutlined } from '@ant-design/icons'
import { Button, Popconfirm } from 'antd'
import PropTypes from 'prop-types'

import { useRetryMenuTitleLabelsAndIngredientsMutation } from '../../hooks'
import { menuTitlePropType } from '../../prop-types'

const MenuTitleRetryLabelAndIngredientsButton = ({ menuTitle, isDisabled }) => {
  const [retry] = useRetryMenuTitleLabelsAndIngredientsMutation()

  const handleOnConfirm = useCallback(
    () => retry(menuTitle),
    [menuTitle, retry],
  )

  return (
    <Popconfirm
      disabled={isDisabled}
      title="Retry labels and ingredients? Retrying a menu title can cause previously curated dishes to get reset, they will appear in the dish list and will need to be curated again."
      onConfirm={handleOnConfirm}
    >
      <Button disabled={isDisabled} icon={<SyncOutlined />} shape="circle" />
    </Popconfirm>
  )
}

MenuTitleRetryLabelAndIngredientsButton.propTypes = {
  menuTitle: menuTitlePropType.isRequired,
  isDisabled: PropTypes.bool,
}

MenuTitleRetryLabelAndIngredientsButton.defaultProps = {
  isDisabled: false,
}

export default MenuTitleRetryLabelAndIngredientsButton
